"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/anchor-is-valid */
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const react_redux_1 = require("react-redux");
const redux_1 = require("redux");
const assets_1 = require("~/assets");
const UI_1 = require("~/components/UI");
const DeletionConfirmationModal_1 = __importDefault(require("~/components/WidgetsManager/RecommendedFastenersWidget/DeletionConfirmationModal"));
const actions_1 = require("~/store/actions");
const events_1 = require("~/utils/events");
const TeamMember_module_scss_1 = __importDefault(require("./TeamMember.module.scss"));
function TeamMember({ user, showControls = false, deleteHandler }) {
    var _a;
    const { t } = (0, react_i18next_1.useTranslation)('profile');
    const [itemSelected, setItemSelected] = (0, react_1.useState)(false);
    const { dispatchTransferOwnership, dispatchResendInvitation } = (0, redux_1.bindActionCreators)({
        dispatchTransferOwnership: actions_1.transferOwnership,
        dispatchResendInvitation: actions_1.resendInvitation,
    }, (0, react_redux_1.useDispatch)());
    const handleTransferOwnership = () => {
        if (user.id) {
            dispatchTransferOwnership(user.id);
        }
    };
    const handleResendInvitation = () => {
        var _a;
        if (user.distributorId) {
            dispatchResendInvitation({ email: (_a = user.email) !== null && _a !== void 0 ? _a : '', distributorId: user.distributorId });
        }
    };
    const handleDelete = () => {
        if (deleteHandler && user.id) {
            deleteHandler(user.id);
        }
    };
    const dropdownStateHandler = (state) => setItemSelected(state);
    const isCurrentUserOwner = user.roleId === 1;
    return (react_1.default.createElement("tr", { className: TeamMember_module_scss_1.default.user, "data-inactive": isCurrentUserOwner, "data-active": itemSelected },
        react_1.default.createElement("td", null, user.active || (!user.active && user.firstName !== '-') ? (user.firstName) : (react_1.default.createElement("img", { src: assets_1.svgBasicPending, alt: "pending" }))),
        react_1.default.createElement("td", null, user.lastName),
        react_1.default.createElement("td", { title: user.email }, user.email),
        react_1.default.createElement("td", { "data-role": "true" }, (_a = user.userRole) === null || _a === void 0 ? void 0 : _a.value),
        showControls && !isCurrentUserOwner && (react_1.default.createElement(UI_1.ElementDropdown, { element: react_1.default.createElement("div", { className: TeamMember_module_scss_1.default.controls, "data-active": itemSelected },
                react_1.default.createElement("img", { src: assets_1.svgBasicDragIcon, alt: "", onClick: () => setItemSelected(!itemSelected), onKeyDown: (event) => {
                        if (event.key === 'Enter' || event.key === 'Accept' || event.key === ' ') {
                            setItemSelected(!itemSelected);
                        }
                    } })), dropdown: react_1.default.createElement("div", { className: TeamMember_module_scss_1.default.dropdown },
                user.active ? (react_1.default.createElement("a", { onKeyDown: (event) => {
                        if (event.key === 'Enter' || event.key === 'Accept' || event.key === ' ') {
                            (0, events_1.showModal)(react_1.default.createElement(DeletionConfirmationModal_1.default, { onSubmit: handleTransferOwnership, startOfTitle: t('titles.startOfTitle'), middleOfTitle: `${user.firstName} ${user.lastName} `, endOfTitle: "", genericMode: true }));
                        }
                    }, onClick: () => {
                        (0, events_1.showModal)(react_1.default.createElement(DeletionConfirmationModal_1.default, { onSubmit: handleTransferOwnership, startOfTitle: t('titles.startOfTitle'), middleOfTitle: `${user.firstName} ${user.lastName} `, endOfTitle: "", genericMode: true }));
                    } }, t('member-edit-dropdown.transfer'))) : (react_1.default.createElement("a", { onClick: handleResendInvitation, onKeyDown: (event) => {
                        if (event.key === 'Enter' || event.key === 'Accept' || event.key === ' ') {
                            handleResendInvitation();
                        }
                    } }, t('member-edit-dropdown.resend'))),
                react_1.default.createElement("a", { onKeyDown: (event) => {
                        if (event.key === 'Enter' || event.key === 'Accept' || event.key === ' ') {
                            (0, events_1.showModal)(react_1.default.createElement(DeletionConfirmationModal_1.default, { middleOfTitle: `${user.firstName} ${user.lastName} `, endOfTitle: t('titles.endOfTitle'), onSubmit: handleDelete }));
                        }
                    }, onClick: () => (0, events_1.showModal)(react_1.default.createElement(DeletionConfirmationModal_1.default, { middleOfTitle: `${user.firstName} ${user.lastName} `, endOfTitle: t('titles.endOfTitle'), onSubmit: handleDelete })) }, t('member-edit-dropdown.delete'))), placement: "left-start", activeStateHandler: dropdownStateHandler }))));
}
TeamMember.defaultProps = {
    deleteHandler: undefined,
};
exports.default = TeamMember;
